import { Attribute } from "@/types/prodcatBaseTypes";

const measurementNameMapping = {
  dimensions: "Product size",
  packageddimensions: "Package size",
  combinedaperturedimensions: "Space needed",
  minimumclearancedimensions: "Space above appliance",
  maximumappliancedepth: "Maximum depth",
};

const validSellingProductTypes = [
  "Washing Machines",
  "Tumble Dryers",
  "Washer Dryers",
  "Spin Dryers",
  "Cookers",
  "Cooker Hoods",
  "Hobs",
  "Ovens",
  "Microwaves",
  "Dishwashers",
  "Freezers",
  "Fridges",
  "Fridge Freezers",
  "Wine Cabinets",
  "Televisions",
];

export function getMeasurementsAttributes(
  attributes: Attribute[],
  sellingProductType: string | undefined,
): Attribute[] {
  const allMeasurements: Attribute[] = [];
  const badDataList = ["mm", "n/a"];

  if (
    !sellingProductType ||
    !validSellingProductTypes.includes(sellingProductType)
  ) {
    return [];
  }

  for (const [key, value] of Object.entries(measurementNameMapping)) {
    const measurementAttribute = attributes.find(
      (attribute) => attribute.key === key,
    );
    if (
      measurementAttribute &&
      measurementAttribute.values[0] &&
      !badDataList.includes(measurementAttribute.values[0].toLowerCase())
    ) {
      allMeasurements.push({ ...measurementAttribute, displayName: value });
    }
  }

  return allMeasurements;
}
